module.exports = __webpack_public_path__ + "static/wave_1-9829d0c6cd597b2ea74fce5610bfead9.svg";